import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Avatar, Button } from "@mui/material";
import { useNavigate } from "react-router";
import styles from "./WaitingSteps.module.scss";
import { Link } from "react-router-dom";

const WaitingDelete: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box className={styles.waiting}>
      <h2>{t("waitingDeletionTasks")}</h2>
      <ul>
        <li>
          <p>{t("publishedMessages.0")}</p>
        </li>
      </ul>
      <p className={styles.orange}>{t("publishedMessages.3")}</p>
      <Avatar>
        <MailOutlineIcon />
      </Avatar>
      <p>
        {t("youCanFollowTheStatusInTheSection")}
        <Link to={"/myinbox"}>{t("myPublications")}</Link>
      </p>
      <Button variant="text" onClick={() => navigate("/")}>
        {t("backToHome")}
      </Button>
    </Box>
  );
};

export default WaitingDelete;
